export default __webpack_public_path__ + "static/media/School.f01673cf.webp";